<template>
	<div class="landscape">
		<div class="layer-landscape clouds-bg"></div>
		<div class="layer-landscape clouds-lonely"></div>
		<div class="layer-landscape mountains"></div>
		<div class="layer-landscape clouds-3"></div>
		<div class="layer-landscape clouds-2"></div>
		<div class="layer-landscape clouds-1"></div>
	</div>
</template>
<script lang="js">
export default {
    name: 'Mountains'
}
</script>
<style lang="scss" scoped>
.landscape {
	width: 100vw;
	height: 100vh;
	background: url("~@/assets/img/moutains/sky.png");
	overflow: hidden;
	position: absolute;
	.layer-landscape {
		position: absolute;
		height: 100%;
		width: 300%;
		filter: drop-shadow(0px 0px 15px rgba(0, 0, 0, 0.1));
		&.clouds-bg {
			background: url("~@/assets/img/moutains/clouds_bg.png");
			background-size: 33%;
			background-repeat: repeat-x;
			background-position: bottom;
			image-rendering: pixelated;
			animation: slide 22s linear infinite;
			z-index: 1;
		}
		&.clouds-lonely {
			background: url("~@/assets/img/moutains/cloud_lonely.png");
			background-size: 33%;
			background-repeat: repeat-x;
			background-position: bottom;
			image-rendering: pixelated;
			animation: slide 14s linear infinite;
			z-index: 3;
		}
		&.mountains {
			background: url("~@/assets/img/moutains/glacial_mountains.png");
			background-size: 33%;
			background-repeat: repeat-x;
			background-position: bottom;
			image-rendering: pixelated;
			animation: slide 18s linear infinite;
			z-index: 2;
		}

		&.clouds-3 {
			background: url("~@/assets/img/moutains/clouds_mg_3.png");
			background-size: 33%;
			background-repeat: repeat-x;
			background-position: bottom;
			image-rendering: pixelated;
			animation: slide 16s linear infinite;
			z-index: 3;
		}

		&.clouds-2 {
			background: url("~@/assets/img/moutains/clouds_mg_2.png");
			background-size: 33%;
			background-repeat: repeat-x;
			background-position: bottom;
			image-rendering: pixelated;
			animation: slide 10s linear infinite;
			z-index: 4;
		}

		&.clouds-1 {
			background: url("~@/assets/img/moutains/clouds_mg_1.png");
			background-size: 33%;
			background-repeat: repeat-x;
			background-position: bottom;
			image-rendering: pixelated;
			animation: slide 12s linear infinite;
			z-index: 5;
		}
		&.paused {
			animation-play-state: paused;
		}
	}
}
@keyframes slide {
	0% {
		transform: translate(0);
	}
	100% {
		transform: translate(-33%);
	}
}
</style>
